import { z } from 'zod'
import { API, handleError } from './api'
import { uploadedImageSchema } from './schemas'

const saveImagesParamsSchema = z.object({
  type: z.enum(['customer', 'garment']),
  id: z.coerce.number(),
  file: z.instanceof(File),
  description: z.preprocess(value => (typeof value === 'string' ? value : ''), z.string()),
})

// group images together
export async function saveImages(rawParams: Record<string, unknown>) {
  try {
    const { type, id, file, description } = saveImagesParamsSchema.parse(rawParams)
    const formData = new FormData()
    formData.append('reference_id', String(id))
    formData.append('image_type', type)
    formData.append('image', file)
    const trimmed = description.trim()
    if (trimmed) formData.append('description', trimmed)
    const response = await API.post(`uploaded_images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return uploadedImageSchema.parse(response.data)
  } catch (error) {
    return handleError(error, 'Save Image')
  }
}

// change to delete image from reference id
export async function deleteImage(imageId: number) {
  try {
    await API.delete(`uploaded_images/${imageId}`)
    return { error: false, message: 'Image deleted' }
  } catch (error) {
    return handleError(error, 'Delete Image')
  }
}
